/* @generated from adl module ferovinum.app.productionorders */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';
import * as ferovinum_app_db from './db';
import * as ferovinum_app_dtos from './dtos';
import * as ferovinum_app_product from './product';

export interface OutputProductItem {
  product: ferovinum_app_product.NewOrExistingProduct;
  quantity: ferovinum_app_db.NumberOfUnits;
  productStockDetails: (ferovinum_app_dtos.SaveProductStockDetailDto[]|null);
}

export function makeOutputProductItem(
  input: {
    product: ferovinum_app_product.NewOrExistingProduct,
    quantity: ferovinum_app_db.NumberOfUnits,
    productStockDetails: (ferovinum_app_dtos.SaveProductStockDetailDto[]|null),
  }
): OutputProductItem {
  return {
    product: input.product,
    quantity: input.quantity,
    productStockDetails: input.productStockDetails,
  };
}

const OutputProductItem_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.productionorders","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"product","default":{"kind":"nothing"},"name":"product","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.product","name":"NewOrExistingProduct"}},"parameters":[]}},{"annotations":[],"serializedName":"quantity","default":{"kind":"nothing"},"name":"quantity","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"NumberOfUnits"}},"parameters":[]}},{"annotations":[],"serializedName":"productStockDetails","default":{"kind":"nothing"},"name":"productStockDetails","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.dtos","name":"SaveProductStockDetailDto"}},"parameters":[]}]}]}}]}},"name":"OutputProductItem","version":{"kind":"nothing"}}};

export const snOutputProductItem: ADL.ScopedName = {moduleName:"ferovinum.app.productionorders", name:"OutputProductItem"};

export function texprOutputProductItem(): ADL.ATypeExpr<OutputProductItem> {
  return {value : {typeRef : {kind: "reference", value : snOutputProductItem}, parameters : []}};
}

export interface ProductionOrderCostBreakdown {
  setupCost: common.BigDecimal;
  pricePerUnit: common.BigDecimal;
  totalCost: common.BigDecimal;
}

export function makeProductionOrderCostBreakdown(
  input: {
    setupCost: common.BigDecimal,
    pricePerUnit: common.BigDecimal,
    totalCost: common.BigDecimal,
  }
): ProductionOrderCostBreakdown {
  return {
    setupCost: input.setupCost,
    pricePerUnit: input.pricePerUnit,
    totalCost: input.totalCost,
  };
}

const ProductionOrderCostBreakdown_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.productionorders","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"setupCost","default":{"kind":"nothing"},"name":"setupCost","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"pricePerUnit","default":{"kind":"nothing"},"name":"pricePerUnit","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"totalCost","default":{"kind":"nothing"},"name":"totalCost","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}}]}},"name":"ProductionOrderCostBreakdown","version":{"kind":"nothing"}}};

export const snProductionOrderCostBreakdown: ADL.ScopedName = {moduleName:"ferovinum.app.productionorders", name:"ProductionOrderCostBreakdown"};

export function texprProductionOrderCostBreakdown(): ADL.ATypeExpr<ProductionOrderCostBreakdown> {
  return {value : {typeRef : {kind: "reference", value : snProductionOrderCostBreakdown}, parameters : []}};
}

export interface CompleteProductionOrderValidationError {
  errors: common_strings.StringNE[];
}

export function makeCompleteProductionOrderValidationError(
  input: {
    errors: common_strings.StringNE[],
  }
): CompleteProductionOrderValidationError {
  return {
    errors: input.errors,
  };
}

const CompleteProductionOrderValidationError_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.productionorders","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"errors","default":{"kind":"nothing"},"name":"errors","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}}]}},"name":"CompleteProductionOrderValidationError","version":{"kind":"nothing"}}};

export const snCompleteProductionOrderValidationError: ADL.ScopedName = {moduleName:"ferovinum.app.productionorders", name:"CompleteProductionOrderValidationError"};

export function texprCompleteProductionOrderValidationError(): ADL.ATypeExpr<CompleteProductionOrderValidationError> {
  return {value : {typeRef : {kind: "reference", value : snCompleteProductionOrderValidationError}, parameters : []}};
}

export interface CreateCompleteProductionOrderReq {
  organisationId: ferovinum_app_db.OrganisationId;
  storageLocationId: ferovinum_app_db.StorageLocationId;
  completionDate: common.LocalDate;
  notes: (common_strings.StringNE|null);
  finishingServiceDescription: common_strings.StringNE;
  totalCost: common.BigDecimal;
  sourceProducts: ferovinum_app_db.SourceProductItem[];
  outputProducts: OutputProductItem[];
}

export function makeCreateCompleteProductionOrderReq(
  input: {
    organisationId: ferovinum_app_db.OrganisationId,
    storageLocationId: ferovinum_app_db.StorageLocationId,
    completionDate: common.LocalDate,
    notes: (common_strings.StringNE|null),
    finishingServiceDescription: common_strings.StringNE,
    totalCost: common.BigDecimal,
    sourceProducts: ferovinum_app_db.SourceProductItem[],
    outputProducts: OutputProductItem[],
  }
): CreateCompleteProductionOrderReq {
  return {
    organisationId: input.organisationId,
    storageLocationId: input.storageLocationId,
    completionDate: input.completionDate,
    notes: input.notes,
    finishingServiceDescription: input.finishingServiceDescription,
    totalCost: input.totalCost,
    sourceProducts: input.sourceProducts,
    outputProducts: input.outputProducts,
  };
}

const CreateCompleteProductionOrderReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.productionorders","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"organisationId","default":{"kind":"nothing"},"name":"organisationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"OrganisationId"}},"parameters":[]}},{"annotations":[],"serializedName":"storageLocationId","default":{"kind":"nothing"},"name":"storageLocationId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"StorageLocationId"}},"parameters":[]}},{"annotations":[],"serializedName":"completionDate","default":{"kind":"nothing"},"name":"completionDate","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"LocalDate"}},"parameters":[]}},{"annotations":[],"serializedName":"notes","default":{"kind":"nothing"},"name":"notes","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"finishingServiceDescription","default":{"kind":"nothing"},"name":"finishingServiceDescription","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"totalCost","default":{"kind":"nothing"},"name":"totalCost","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"BigDecimal"}},"parameters":[]}},{"annotations":[],"serializedName":"sourceProducts","default":{"kind":"nothing"},"name":"sourceProducts","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SourceProductItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"outputProducts","default":{"kind":"nothing"},"name":"outputProducts","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.productionorders","name":"OutputProductItem"}},"parameters":[]}]}}]}},"name":"CreateCompleteProductionOrderReq","version":{"kind":"nothing"}}};

export const snCreateCompleteProductionOrderReq: ADL.ScopedName = {moduleName:"ferovinum.app.productionorders", name:"CreateCompleteProductionOrderReq"};

export function texprCreateCompleteProductionOrderReq(): ADL.ATypeExpr<CreateCompleteProductionOrderReq> {
  return {value : {typeRef : {kind: "reference", value : snCreateCompleteProductionOrderReq}, parameters : []}};
}

export interface CreateCompleteProductionOrderResp_Success {
  kind: 'success';
  value: ferovinum_app_db.ProductionOrderId;
}
export interface CreateCompleteProductionOrderResp_Error {
  kind: 'error';
  value: CompleteProductionOrderValidationError;
}

export type CreateCompleteProductionOrderResp = CreateCompleteProductionOrderResp_Success | CreateCompleteProductionOrderResp_Error;

export interface CreateCompleteProductionOrderRespOpts {
  success: ferovinum_app_db.ProductionOrderId;
  error: CompleteProductionOrderValidationError;
}

export function makeCreateCompleteProductionOrderResp<K extends keyof CreateCompleteProductionOrderRespOpts>(kind: K, value: CreateCompleteProductionOrderRespOpts[K]) { return {kind, value}; }

const CreateCompleteProductionOrderResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.productionorders","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"ProductionOrderId"}},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.productionorders","name":"CompleteProductionOrderValidationError"}},"parameters":[]}}]}},"name":"CreateCompleteProductionOrderResp","version":{"kind":"nothing"}}};

export const snCreateCompleteProductionOrderResp: ADL.ScopedName = {moduleName:"ferovinum.app.productionorders", name:"CreateCompleteProductionOrderResp"};

export function texprCreateCompleteProductionOrderResp(): ADL.ATypeExpr<CreateCompleteProductionOrderResp> {
  return {value : {typeRef : {kind: "reference", value : snCreateCompleteProductionOrderResp}, parameters : []}};
}

export type PreviewCompleteProductionOrderReq = CreateCompleteProductionOrderReq;

const PreviewCompleteProductionOrderReq_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.productionorders","decl":{"annotations":[],"type_":{"kind":"type_","value":{"typeParams":[],"typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.productionorders","name":"CreateCompleteProductionOrderReq"}},"parameters":[]}}},"name":"PreviewCompleteProductionOrderReq","version":{"kind":"nothing"}}};

export const snPreviewCompleteProductionOrderReq: ADL.ScopedName = {moduleName:"ferovinum.app.productionorders", name:"PreviewCompleteProductionOrderReq"};

export function texprPreviewCompleteProductionOrderReq(): ADL.ATypeExpr<PreviewCompleteProductionOrderReq> {
  return {value : {typeRef : {kind: "reference", value : snPreviewCompleteProductionOrderReq}, parameters : []}};
}

export interface PreviewCompleteProductionOrderSuccess {
  sourceProducts: ferovinum_app_db.SourceProductItem[];
  outputProducts: OutputProductItem[];
  costBreakdown: ProductionOrderCostBreakdown;
}

export function makePreviewCompleteProductionOrderSuccess(
  input: {
    sourceProducts: ferovinum_app_db.SourceProductItem[],
    outputProducts: OutputProductItem[],
    costBreakdown: ProductionOrderCostBreakdown,
  }
): PreviewCompleteProductionOrderSuccess {
  return {
    sourceProducts: input.sourceProducts,
    outputProducts: input.outputProducts,
    costBreakdown: input.costBreakdown,
  };
}

const PreviewCompleteProductionOrderSuccess_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.productionorders","decl":{"annotations":[],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"sourceProducts","default":{"kind":"nothing"},"name":"sourceProducts","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.db","name":"SourceProductItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"outputProducts","default":{"kind":"nothing"},"name":"outputProducts","typeExpr":{"typeRef":{"kind":"primitive","value":"Vector"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.productionorders","name":"OutputProductItem"}},"parameters":[]}]}},{"annotations":[],"serializedName":"costBreakdown","default":{"kind":"nothing"},"name":"costBreakdown","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.productionorders","name":"ProductionOrderCostBreakdown"}},"parameters":[]}}]}},"name":"PreviewCompleteProductionOrderSuccess","version":{"kind":"nothing"}}};

export const snPreviewCompleteProductionOrderSuccess: ADL.ScopedName = {moduleName:"ferovinum.app.productionorders", name:"PreviewCompleteProductionOrderSuccess"};

export function texprPreviewCompleteProductionOrderSuccess(): ADL.ATypeExpr<PreviewCompleteProductionOrderSuccess> {
  return {value : {typeRef : {kind: "reference", value : snPreviewCompleteProductionOrderSuccess}, parameters : []}};
}

export interface PreviewCompleteProductionOrderResp_Success {
  kind: 'success';
  value: PreviewCompleteProductionOrderSuccess;
}
export interface PreviewCompleteProductionOrderResp_Error {
  kind: 'error';
  value: CompleteProductionOrderValidationError;
}

export type PreviewCompleteProductionOrderResp = PreviewCompleteProductionOrderResp_Success | PreviewCompleteProductionOrderResp_Error;

export interface PreviewCompleteProductionOrderRespOpts {
  success: PreviewCompleteProductionOrderSuccess;
  error: CompleteProductionOrderValidationError;
}

export function makePreviewCompleteProductionOrderResp<K extends keyof PreviewCompleteProductionOrderRespOpts>(kind: K, value: PreviewCompleteProductionOrderRespOpts[K]) { return {kind, value}; }

const PreviewCompleteProductionOrderResp_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.app.productionorders","decl":{"annotations":[],"type_":{"kind":"union_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"success","default":{"kind":"nothing"},"name":"success","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.productionorders","name":"PreviewCompleteProductionOrderSuccess"}},"parameters":[]}},{"annotations":[],"serializedName":"error","default":{"kind":"nothing"},"name":"error","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"ferovinum.app.productionorders","name":"CompleteProductionOrderValidationError"}},"parameters":[]}}]}},"name":"PreviewCompleteProductionOrderResp","version":{"kind":"nothing"}}};

export const snPreviewCompleteProductionOrderResp: ADL.ScopedName = {moduleName:"ferovinum.app.productionorders", name:"PreviewCompleteProductionOrderResp"};

export function texprPreviewCompleteProductionOrderResp(): ADL.ATypeExpr<PreviewCompleteProductionOrderResp> {
  return {value : {typeRef : {kind: "reference", value : snPreviewCompleteProductionOrderResp}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.app.productionorders.OutputProductItem" : OutputProductItem_AST,
  "ferovinum.app.productionorders.ProductionOrderCostBreakdown" : ProductionOrderCostBreakdown_AST,
  "ferovinum.app.productionorders.CompleteProductionOrderValidationError" : CompleteProductionOrderValidationError_AST,
  "ferovinum.app.productionorders.CreateCompleteProductionOrderReq" : CreateCompleteProductionOrderReq_AST,
  "ferovinum.app.productionorders.CreateCompleteProductionOrderResp" : CreateCompleteProductionOrderResp_AST,
  "ferovinum.app.productionorders.PreviewCompleteProductionOrderReq" : PreviewCompleteProductionOrderReq_AST,
  "ferovinum.app.productionorders.PreviewCompleteProductionOrderSuccess" : PreviewCompleteProductionOrderSuccess_AST,
  "ferovinum.app.productionorders.PreviewCompleteProductionOrderResp" : PreviewCompleteProductionOrderResp_AST
};
